import { render, staticRenderFns } from "./BackofficeRightNavBar.vue?vue&type=template&id=4c05075a"
import script from "./BackofficeRightNavBar.vue?vue&type=script&lang=ts"
export * from "./BackofficeRightNavBar.vue?vue&type=script&lang=ts"
import style0 from "./BackofficeRightNavBar.vue?vue&type=style&index=0&id=4c05075a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports